import script from "./ThreeDSnapshotViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDSnapshotViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDSnapshotViewer.vue?vue&type=style&index=0&id=350334f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350334f0"]])

export default __exports__